<template>
    <el-dialog custom-class="video_preview_modal" v-model="modalVisible" @open="openModal" @close="closeModal" :destroy-on-close="true" :append-to-body="true">
        <div v-loading="loading">
            <video-js :options="videoPlayerOptions" :sources="sources" @onPlayerReady='onPlayerReady'/>
        </div>
    </el-dialog>
</template>

<script>
    import VideoJs from "@/components/VideoJs/VideoJs.vue";

    import {
        ref,
        onMounted,
        inject,
    } from 'vue';

    import {
    } from 'vuex'
    import {
    } from 'vue-router'
    export default {
        components: {
            VideoJs
        },
        props: {
            modalName: {
                type: String
            },
            options: {
                type: Object
            }
        },
        setup(props) {
            const $mitt = inject('$mitt');
            const modalVisible = ref(false);

            const loading = ref(true);

            const videoUrl = ref(null);
            const videoType = ref(null);

            const videoPlayer = ref(null);
            const videoPlayerOptions = {
                class: 'videojs_comp',
                preload: 'auto',
                autoplay: false,
                controls: true,
                plugins: {
                    seekButtons: {
                        forward: 15,
                        back: 15,
                        forwardIndex: 3,
                        backIndex: 2
                    }
                },
                fluid: true,
                bigPlayButton: false,
                controlBar: {
                    children: [
                        "progressControl",
                        "currentTimeDisplay",
                        // "remainingTimeDisplay",
                        "playToggle",
                        "durationDisplay",
                        "timeDivider",
                        "fullscreenToggle",
                        "volumeMenuButton",
                        "muteToggle",
                    ]
                },
            }

            const onPlayerReady = () =>{
                loading.value = false;
            }

            $mitt.on(props.modalName, (options) => {
                modalVisible.value = options.show;
                videoUrl.value = options.params.videoUrl;
                videoType.value = options.params.videoType;
            });


            onMounted(() => {
                console.log(videoPlayer.value);
            })

            const sources = ref([])

            const openModal = () => {
                loading.value = true
                sources.value.push({
                    src: videoUrl.value,
                    type: videoType.value,
                })
            };
            const closeModal = () => {
                modalVisible.value = false;
                sources.value = []
            };

            return {
                openModal,
                closeModal,
                // loading,
                modalVisible,
                videoPlayerOptions,
                sources,
                loading,
                onPlayerReady
            }
        }
    }
</script>